/*
 * Shopify owns the consent choice; this file only reads processing permissions.
 * https://shopify.dev/docs/api/customer-privacy
 * https://learn.microsoft.com/en-us/clarity/setup-and-installation/clarity-consent-api-v2
 */
(() => {
  'use strict';

  if (window.__calmConsentInitialized) return;
  window.__calmConsentInitialized = true;

  const clarityProject = 'qeujqlo0w0';
  const clarityScriptId = 'calm-clarity-tag';
  let privacyReady = false;
  let privacyLoading = false;
  let privacyAttempts = 0;
  let privacyTimer;
  let clarityRequested = false;
  let lastConsent = '';

  function schedulePrivacy() {
    if (privacyTimer || privacyAttempts >= 40) return;
    privacyTimer = window.setTimeout(() => {
      privacyTimer = undefined;
      preparePrivacy();
    }, 250);
  }

  function preparePrivacy() {
    if (privacyReady) {
      syncConsent();
      return;
    }
    if (privacyLoading) return;
    privacyAttempts += 1;
    const shopify = window.Shopify;
    if (!shopify || typeof shopify.loadFeatures !== 'function') {
      schedulePrivacy();
      return;
    }
    privacyLoading = true;
    try {
      shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], (error) => {
        privacyLoading = false;
        if (error) {
          schedulePrivacy();
          return;
        }
        privacyReady = true;
        syncConsent();
      });
    } catch (_) {
      privacyLoading = false;
      schedulePrivacy();
    }
  }

  function syncConsent() {
    let analytics = false;
    let marketing = false;
    const privacy = window.Shopify && window.Shopify.customerPrivacy;
    if (privacyReady && privacy) {
      try {
        analytics = typeof privacy.analyticsProcessingAllowed === 'function'
          && privacy.analyticsProcessingAllowed() === true;
        marketing = typeof privacy.marketingAllowed === 'function'
          && privacy.marketingAllowed() === true;
      } catch (_) {
        // An unavailable permission is denied; never infer consent from a region or cookie.
        analytics = false;
        marketing = false;
      }
    }

    // Do not fetch Clarity at all before Shopify allows analytics processing.
    if (!analytics && !clarityRequested && typeof window.clarity !== 'function') return;
    if (typeof window.clarity !== 'function') {
      window.clarity = function () {
        (window.clarity.q = window.clarity.q || []).push(arguments);
      };
    }

    const consent = {
      ad_Storage: marketing ? 'granted' : 'denied',
      analytics_Storage: analytics ? 'granted' : 'denied'
    };
    const signature = consent.ad_Storage + ':' + consent.analytics_Storage;
    if (signature !== lastConsent) {
      // Queue before fetching the tag; keep granular permissions and later revocations.
      window.clarity('consentv2', consent);
      lastConsent = signature;
    }
    if (!analytics || clarityRequested) return;

    clarityRequested = true;
    const script = document.createElement('script');
    script.id = clarityScriptId;
    script.async = true;
    script.src = 'https://www.clarity.ms/tag/' + clarityProject;
    script.onload = () => {
      lastConsent = '';
      syncConsent();
    };
    script.onerror = () => {
      clarityRequested = false;
      lastConsent = '';
      script.remove();
    };
    document.head.appendChild(script);
  }

  function refreshConsent() {
    privacyAttempts = 0;
    preparePrivacy();
  }

  // The event is not replayed on registration, so read the initial state as well.
  document.addEventListener('visitorConsentCollected', refreshConsent);
  window.addEventListener('pageshow', refreshConsent);
  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'visible') refreshConsent();
  });

  preparePrivacy();
})();
